import { type StoreActionApi } from 'react-sweet-state';

import { STARTING_PROGRESS } from './STARTING_PROGRESS';
import type { ChatMessageResearchStore } from './types';

type AddResearchPlanArgs = {
	messageId: string;
	content: string;
	title?: string;
	roundId: number;
};

type ChatMessageResearchStoreAction = (api: StoreActionApi<ChatMessageResearchStore>) => void;

export const addResearchPlan: (args: AddResearchPlanArgs) => ChatMessageResearchStoreAction =
	({ messageId, content, title = 'Research Plan', roundId }) =>
	({ getState, setState }: StoreActionApi<ChatMessageResearchStore>) => {
		const currentState = getState();
		const message = currentState[messageId];

		// Set the research plan on the message
		setState({
			...currentState,
			[messageId]: {
				...(message ?? { currentProgress: STARTING_PROGRESS, steps: {}, researchPlans: {} }),
				researchPlans: {
					...message?.researchPlans,
					[roundId]: {
						title,
						content,
						roundId,
					},
				},
			},
		});
	};
